<template>
    <div id="paintworkformpage">
        <div class="top-buttons">
            <ui5-button @click="$router.push('/menu')">{{ trans('pages.paintwork_form.back') }}</ui5-button>
        </div>

        <ui5-list :busy="loading">
            <ui5-li
                v-for="item in items"
                @click="goTo(item)"
                :key="item.paintworkorderId">
                {{ getDescription(item) }}
            </ui5-li>
        </ui5-list>

        <div v-if="finished">{{ trans('pages.paintwork_form.all_paint_work_orders_loaded') }}</div>
    </div>
</template>
<script>
import paintWorkOrderApi from '../api/paintWorkOrder';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            finished: false,
            loading: false,
            items: null,
        };
    },
    methods: {
        goTo(item) {
            this.$router.push('/paintworkformdetails/' + item.paintworkorderId);
        },
        getDescription(item) {
            return (
                item.paintworkorderId +
                ' - ' +
                item.dateCreated +
                ' - ' +
                (item.paintshop ? item.paintshop.name : '') +
                ' - ' +
                (item.sawn ? this.trans('pages.paintwork_form.sawn') : this.trans('pages.paintwork_form.in_progress'))
            );
        },
        load() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            paintWorkOrderApi
                .list(this.items ? this.items.length : 0, 50)
                .then((response) => {
                    if (!this.items) {
                        this.items = [];
                    }
                    const newItems = response.data.data;
                    if (newItems.length) {
                        this.finished = false;
                        this.items.push(...newItems);
                    } else {
                        this.finished = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.load();
        this.$bus.$on('bottom-scroll', this.load);
    },
    beforeRouteLeave(to, from, next) {
        this.$bus.$off('bottom-scroll', this.load);
        next();
    },
};
</script>
